//@flow

import React from 'react';
import moment from 'moment';
import { Col } from 'reactstrap';
import type { Node } from 'react';

import { useDocumentTitle } from '../../../hooks';
import { WhitePanel, PaymentSummarySpan as Span, Prices } from '../../../components';

type Invoice = {
  amount: string,
  authId: string | null,
  currency: string,
  discount: string,
  id: number,
  rate: string,
  status: string,
  tax: string,
  trek: {
    id: string,
    pax: number,
    paymentPlan: string,
    startDate: string,
    trekTitle: string,
    numberOfDays: string,
    creatorName: string,
  },
};

type Props = {
  /**
   *  basically this is the same data from trek overview
   */
  trekData: Object,
  /**
   *  represents the booking information related to the trek
   */
  invoice: Invoice,
  children: Node,
};

export default function Summary(props: Props) {
  const {
    invoice: {
      amount,
      currency,
      discount,
      rate,
      trek: {
        pax,
        paymentPlan,
        trekTitle: name,
        numberOfDays,
        creatorName,
        startDate,
        trekTitle,
      },
    },
    children,
  } = props;

  useDocumentTitle(`Trek Payment | ${trekTitle || ''}`, trekTitle);

  const formatDate = date => moment(date).format('ddd DD MMM YY');

  return (
    <Col lg="6" className="trek-summary">
      <WhitePanel>
        <h2>TREK SUMMARY</h2>
        <p className="trek-name">
          <strong>{name}</strong>
        </p>
        <ul className="service-list">
          <Span title="Creator" value={creatorName} />
          <Span title="Start Date" value={`${formatDate(startDate)}`} />
          <Span title="No. of Days" value={numberOfDays} />
          <Span title="No. of People" value={pax} />
          <Span
            title="Payment Plan"
            value={paymentPlan === 'N' ? 'Non-Refundable' : 'Refundable'}
          />
        </ul>
        <hr />
        <Prices
          discount={discount}
          basePrice={rate}
          grandTotal={amount}
          currency={currency}
        />
        {children}
      </WhitePanel>
    </Col>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Trek/Common/Summary.js